const PATH = 'fe.components.measure.view.header';

const messages = {
  observationDate: {
    key: `${PATH}.observation_date`,
    defaultValue: 'Observation Date:'
  },
  observationDateMobile: {
    key: `${PATH}.observation_date_mobile`,
    defaultValue: 'Date:'
  },
  classroom: {
    key: `${PATH}.classroom`,
    defaultValue: 'Classroom:'
  },
  observationTool: {
    key: `${PATH}.observation_tool`,
    defaultValue: 'Observation Tool:'
  },
  observationToolMobile: {
    key: `${PATH}.observation_tool_mobile`,
    defaultValue: 'Tool:'
  },
  jobId: {
    key: `${PATH}.job_id`,
    defaultValue: 'Job ID:'
  },
  educators: {
    key: `${PATH}.educators`,
    defaultValue: 'Educator(s):'
  },
  center_name: {
    key: `${PATH}.center_name`,
    defaultValue: 'Center Name:'
  },
  language: {
    key: `${PATH}.language`,
    defaultValue: 'Language:'
  },
  codePrimary: {
    key: `${PATH}.code_primary`,
    defaultValue: 'Double Code: Primary'
  },
  codeSecondary: {
    key: `${PATH}.code_secondary`,
    defaultValue: 'Double Code: Secondary'
  },
  prek3rd: {
    key: `${PATH}.prek_3rd`,
    defaultValue: 'Pre-K–3rd'
  },
  it: {
    key: `${PATH}.it`,
    defaultValue: 'Infant-Toddler'
  }
};

export default messages;
